module.exports = __webpack_public_path__ + "static/media/charger-pin-multiple.5c4d9ce7.svg";